export default __webpack_public_path__ + "static/media/ow1.97127f34.webp";